import { AdvFilterCommand, AdvFilterPicker, AdvFilterResult, AutoCompleteKeyWord } from "components/AdvFilter";
import { CmdGroup, CmdTopicNoSubs, CmdUser, CommandLabels } from "components/AdvFilter/CommonCommands";
import MuiContainer from "components/MuiExtras/MuiContainer";
import MuiPaper from "components/MuiExtras/MuiPaper";
import { WithSnackbar, withSnackbar } from "components/SnackbarProvider/Snackbar";
import { MemberType } from "models/ApiEnums";
import { DashboardKnowledgeTestAppliedSummaryColumn, DashboardUserAndGroupsAndManagersBaseFilter } from "models/ApiModels";
import * as React from "react";
import { WithTranslation, withTranslation } from "react-i18next";
import { KnowledgeTestAppliedAnswerGraph } from "views/Dashboards/KnowledgeTestDashboard/KnowledgeTestAppliedAnswerGraph";
import { KnowledgeTestAppliedOthersGraph } from "views/Dashboards/KnowledgeTestDashboard/KnowledgeTestAppliedOthersGraph";
import KnowledgeTestAppliedTiles from "views/Dashboards/KnowledgeTestDashboard/KnowledgeTestAppliedTiles";
import KnowledgeTestFilter from "views/Dashboards/KnowledgeTestDashboard/KnowledgeTestFilter";
import { KnowledgeTestTabs, TabOptions } from "views/Dashboards/KnowledgeTestDashboard/KnowledgeTestTabs";

/////////////////////////////////////////////////////////////////////////////////////

interface IState {
    tile: DashboardKnowledgeTestAppliedSummaryColumn;
    filter: DashboardUserAndGroupsAndManagersBaseFilter;
    advFilters: AdvFilterResult[];
}

interface IProps {
    onTabChange: (tabOptions: TabOptions) => void;
}

type Props = IProps & WithSnackbar & WithTranslation;

/////////////////////////////////////////////////////////////////////////////////////

class KnowledgeTestAppliedDashboard extends React.PureComponent<Props, IState> {

    constructor(props: Props) {
        super(props);

        this.state = {
            tile: DashboardKnowledgeTestAppliedSummaryColumn.Answered,
            filter: null,
            advFilters: []
        };
    }

    ///
    private handleSelectTopic = (topicId: string, name: string, thumbnailUrl: string) => {
        this.setState(({ advFilters }) => {

            advFilters = advFilters.filter(p => p.keyword != AutoCompleteKeyWord);

            advFilters.push({
                keyword: AutoCompleteKeyWord,
                value: { key: topicId, label: name, thumbnailUrl: thumbnailUrl } as AutoCompleteDataModel,
                text: name
            });

            return { advFilters };
        });

        this.props.snackbar.showMessage(this.props.t("Views.Dashboards.KnowledgeTest.Filter.FilteringTopicText", { name: name }));
    };

    ///
    private handleSelectUser = (userId: string, name: string) => {

        this.setState(({ advFilters }) => {

            advFilters = advFilters.filter(p => p.keyword != CmdUser);

            advFilters.push({
                keyword: CmdUser,
                value: userId,
                text: name
            });

            return { advFilters };
        });

        this.props.snackbar.showMessage(this.props.t("Views.Dashboards.KnowledgeTest.Filter.FilteringTestText", { name: name }));
    };

    ///
    private getFilter(): DashboardUserAndGroupsAndManagersBaseFilter {
        const { advFilters } = this.state;

        var topicFilter = advFilters.find(p => p.keyword == AutoCompleteKeyWord);

        const user = advFilters.find(p => p.keyword == CmdUser);
        const group = advFilters.find(p => p.keyword == CmdGroup);
        const includeSubtopics = advFilters.find(p => p.keyword == CmdTopicNoSubs) == null;

        return {
            topicId: topicFilter == null
                ? null
                : topicFilter.value.key,

            includeSubtopics: includeSubtopics,

            memberId: user == null && group == null
                ? null
                : user == null
                    ? group.value
                    : user.value,

            managerId: null,
            managerDeepTeam: null,

            memberType: user == null && group == null
                ? null
                : user == null
                    ? MemberType.Group
                    : MemberType.User,
        };
    }

    ///
    private get dashboardKnowledgeTestCommands(): AdvFilterCommand[] {
        const cmdLabels = CommandLabels();
        return [
            { keyword: CmdTopicNoSubs, displayName: cmdLabels[CmdTopicNoSubs], picker: null, group: 1, canRepeat: false },
            { keyword: CmdUser, displayName: cmdLabels[CmdUser], picker: AdvFilterPicker.User, group: 2, canRepeat: false, optionGroup: "member" },
            { keyword: CmdGroup, displayName: cmdLabels[CmdGroup], picker: AdvFilterPicker.Group, group: 2, canRepeat: false, optionGroup: "member" },
        ];
    }

    ///
    public render() {
        const { advFilters, tile } = this.state;

        const filter = this.getFilter();

        return (
            <>
                <KnowledgeTestFilter
                    advFilters={advFilters}
                    commands={this.dashboardKnowledgeTestCommands}
                    onFilterChange={(advFilters) => this.setState({ advFilters })}
                />

                <KnowledgeTestTabs
                    currentTab={TabOptions.Applied}
                    onTabChange={this.props.onTabChange}
                />


                <KnowledgeTestAppliedTiles
                    activeTile={tile}
                    filter={filter}
                    onChange={
                        (tile) => {
                            this.setState({ tile });
                        }
                    }
                />

                <MuiContainer margin="normal">
                    <MuiPaper borderVariant="accentedRound" borderColor="warning">
                        {
                            tile == DashboardKnowledgeTestAppliedSummaryColumn.Answered
                                ? <KnowledgeTestAppliedAnswerGraph
                                    {...this.props}
                                    filter={filter}
                                    onSelectUser={this.handleSelectUser}
                                    onSelectTopic={this.handleSelectTopic} />
                                : <KnowledgeTestAppliedOthersGraph
                                    {...this.props}
                                    tile={tile}
                                    filter={filter}
                                    onSelectUser={this.handleSelectUser}
                                    onSelectTopic={this.handleSelectTopic} />
                        }
                    </MuiPaper>
                </MuiContainer>
            </>
        );
    }
}

export default withSnackbar(withTranslation()(KnowledgeTestAppliedDashboard));